import { useState, useEffect } from "react";
import { ReactLenis } from "lenis/react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Transformation from "@/components/Transformation";
import LoungeExperience from "@/components/LoungeExperience";
import DesignDetails from "@/components/DesignDetails";
import Business from "@/components/Business";
import Partnership from "@/components/Partnership";
import Footer from "@/components/Footer";

function Preloader() {
  return (
    <motion.div
      key="preloader"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-ink"
      initial={{ opacity: 1 }}
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
    >
      <motion.span
        initial={{ opacity: 0, letterSpacing: "0.5em" }}
        animate={{ opacity: 1, letterSpacing: "0.28em" }}
        transition={{ duration: 1, ease: "easeOut" }}
        className="font-sans text-xs uppercase tracking-overline text-brass"
      >
        Laundry Ventures
      </motion.span>
    </motion.div>
  );
}

export default function App() {
  const reduce = useReducedMotion();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), reduce ? 100 : 1300);
    return () => clearTimeout(t);
  }, [reduce]);

  return (
    <ReactLenis
      root
      options={{ lerp: 0.09, smoothWheel: !reduce, duration: 1.2 }}
    >
      <div className="App bg-cream">
        <AnimatePresence>{loading && <Preloader />}</AnimatePresence>

        <Navbar />
        <main>
          <Hero />
          <Transformation />
          <EditorialMarquee dark={false} />
          <LoungeExperience />
          <DesignDetails />
          <EditorialMarquee dark />
          <Business />
          <Partnership />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}
